import { prospectType } from '../cip-business-sign-up.props.autogenerated';

export const mapProspectType = (type?: string): string => {
    switch (type) {
        case prospectType.buyer:
            return '1';
        case prospectType.seller:
            return '2';
        case prospectType.selectable:
        default:
            return '0';
    }
};
